import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../model/address.model';

@Pipe({
    name: 'multilineAddress'
})
export class MultilineAddressPipe implements PipeTransform {

    transform(address: Address): string {
        if (!address) {
            return '';
        }

        const townPostCode = [
            !!address.townOrCity ? address.townOrCity : '',
            !!address.postCode ? address.postCode : ''
        ];

        let addressTokens = [
            !!address.line1 ? address.line1 : '',
            !!address.line2 ? address.line2 : '',
            trim(townPostCode).join(' '),
            !!address.province ? address.province : '',
            !!address.country ? address.country : ''
        ];

        addressTokens = trim(addressTokens);

        return addressTokens.join(',\n');

    }
}

const trim = (list: string[]) => list
    .map(s => s.trim())
    .filter(s => !!s && s !== '');
